define((require) => {
    "use strict";

    var ImprovedView = require("editor/zbone/ImprovedView"),
        template     = require("ui/user/BrowserSupportView.tpl");

    return ImprovedView.extend({
        className: "supported-browsers zmags-section",

        transitions: {
            "in": "pt-page-scaleUp",
            out: "pt-page-scaleDown"
        },

        template: template
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/user/BrowserSupportView.js